(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("autocomplete", [], factory);
	else if(typeof exports === 'object')
		exports["autocomplete"] = factory();
	else
		root["autocomplete"] = factory();
})(this, function() {
return 